import Hero from "components/shared/hero/Hero";
import Title from "components/shared/hero/title/Title";

import {
    HeroStyled,
    Paragraph,
    Text,
    Image,
    DoublerImage
} from "./DoublerHero.styled";

function DoublerHero() {
    const breadcrumbItems = [
        {
            title: "Verdubbelaar",
            url: "/verdubbelaar"
        }
    ];

    return (
        <Hero breadcrumbs={breadcrumbItems}>
            <HeroStyled>
                <Image imageType="desktop">
                    <DoublerImage
                        src="/images/doubler-desktop.webp"
                        alt="Doubler"
                        width={390}
                        height={310}
                    />
                </Image>
                <Text>
                    <Title align="left">Verdubbelaar</Title>
                    <Paragraph>
                        Maak nu kans op een verdubbeling van je Lees!
                        Cadeaukaart waarde! Vul onderstaande gegevens in. Wij
                        trekken elke eerste maandag van de maand een winnaar,
                        die per mail zal worden geïnformeerd.
                    </Paragraph>
                </Text>
                <Image imageType="mobile">
                    <DoublerImage
                        src="/images/doubler-mobile.png"
                        alt="Doubler"
                        width={280}
                        height={255}
                    />
                </Image>
            </HeroStyled>
        </Hero>
    );
}

export default DoublerHero;
